// Configuración para OpenID Connect
const authority = process.env.REACT_APP_OIDC_AUTHORITY;
const client_id = process.env.REACT_APP_OIDC_CLIENT_ID;
const redirect_uri = process.env.REACT_APP_OIDC_REDIRECT_URI;

export const oidcConfig = {
  authority,
  client_id,
  redirect_uri,
  post_logout_redirect_uri: process.env.REACT_APP_OIDC_POST_LOGOUT_REDIRECT_URI,
  scope: process.env.REACT_APP_OIDC_SCOPE || "openid profile email",
  response_type: process.env.REACT_APP_OIDC_RESPONSE_TYPE || "code",
  useRefreshToken: true,
  automaticSilentRenew: true,
  loadUserInfo: true,
  filterProtocolClaims: true,
  clockSkew: 300, // 5 minutos de tolerancia
  // Configuraciones adicionales para debugging
  revokeAccessTokenOnSignout: true,
  // Manejar proveedores que no tienen endpoint de logout
  monitorSession: false,
  stopCheckSessionOnError: true
};
